import React from 'react'
import { StyledLink } from './StyledComponents';
import { useTranslation } from 'react-i18next';

const WhitepapersTab = (props) => {
    const { t } = useTranslation()

    return (
        <div className='container'>
            <div className='whitepapers-tab'>
                <ul className='list-unstyled'>
                    <StyledLink href="/whitepapers">
                        <li className={props.allWhitepapersActive ? "active" : ""}>
                            {t('whitepapers-tab.all-whitepapers')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/banking-whitepaper">
                        <li className={props.bankingActive ? "active" : ""}>
                        {t('whitepapers-tab.banking-whitepaper')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/document-security-whitepaper">
                        <li className={props.documentSecurityActive ? "active" : ""}>
                        {t('whitepapers-tab.document-security-whitepaper')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/eu-dcc-whitepaper">
                        <li className={props.euDCCActive ? "active" : ""}>
                        {t('whitepapers-tab.eu-dcc-whitepaper')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/hr-document-security-whitepaper">
                        <li className={props.hrDocumentSecurityActive ? "active" : ""}>
                        {t('whitepapers-tab.hr-document-security-whitepaper')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/pdf-stamping-whitepaper">
                        <li className={props.pdfStampingActive ? "active" : ""}>
                        {t('whitepapers-tab.pdf-stamping-whitepaper')}
                        </li>
                    </StyledLink>
                    <StyledLink href="/whitepapers/testing-inspection-whitepaper">
                        <li className={props.testingInspectionActive ? "active" : ""}>
                        {t('whitepapers-tab.testing-inspection-whitepaper')}
                        </li>
                    </StyledLink>

                </ul>
            </div>
        </div>
    )
}

export default WhitepapersTab